import Keycloak from "keycloak-js";

let keycloakInstance = null;

const getKeycloakInstance = () => {
  if (!keycloakInstance) {
    console.log("Initializing Keycloak..."); // ✅ Debug log
    keycloakInstance = new Keycloak({
      url: import.meta.env.VITE_KEYCLOAK_URL,
      realm: "meditimexorg",
      clientId: "meditimexapp",
      //KeyclockResponseType: "code",
    });
  } else {
    console.warn("Keycloak instance already exists, reusing it."); // ✅ Warn if already exists
  }
  return keycloakInstance;
};

export default getKeycloakInstance;